var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { GBTypography } from '@leapfinance/geebee-component-library';
import { Button } from '@mui/material';
var VASRequestSectionHeader = function (_a) {
    var accordionTitle = _a.accordionTitle, overallCtaProps = _a.overallCtaProps, showOverallCta = _a.showOverallCta, overallCtaText = _a.overallCtaText, overallCtaTextProps = _a.overallCtaTextProps;
    return (React.createElement("div", { className: "lfc-flex lfc-items-center lfc-justify-between" },
        React.createElement(GBTypography, { variant: "h2Semibold" }, accordionTitle !== null && accordionTitle !== void 0 ? accordionTitle : 'Value added services'),
        showOverallCta ? React.createElement(Button, __assign({}, overallCtaProps), overallCtaText !== null && overallCtaText !== void 0 ? overallCtaText : 'See all requests') : React.createElement(React.Fragment, null)));
};
export default VASRequestSectionHeader;
//# sourceMappingURL=VASRequestSectionHeader.js.map